export const STORE_UGC = "STORE_UGC";
export const DELETE_RECIPE = "DELETE_RECIPE";
export const DELETE_MULTIPLE_RECIPES = "DELETE_MULTIPLE_RECIPES";
export const CLEAR_RECIPES = "CLEAR_RECIPES";

export const IS_IN_STORAGE = "IS_IN_STORAGE";
export const GET_SIZE = "GET_SIZE";
export const GET_STORAGE_RECIPES = "GET_STORAGE_RECIPES";
